import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BroadcastCampaignForm from "./BroadcastCampaignForm";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import Loader from "../../ui/Loader";
import MultiSelect from "../../components-react/MultiSelect";
import CloseSubmitBtn from "../custom-comps/CloseSubmitBtn";
import { validateCampaignForm } from "../../broadcast-system/Validations";
import { ReloadIcon } from "../../../images/icons/icons";

const CommonBroadForm = ({
  from,
  filters,
  allFilters,
  userInfoData,
  closeModal,
  setIsFilterSegmentShown,
  selectedTab,
}) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const [allMembers, setAllMembers] = useState([]);

  const forminitials = {
    selectedMembers: [],
    totalMembers: 0,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNextClick = () => {
    const errors = validateCampaignForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setIsSubmit(true);
      setIsFilterSegmentShown(false);
    }
  };

  const handleBackClick = () => {
    setIsSubmit(false);
    setIsFilterSegmentShown(true);
  };

  const handleReloadMembers = () => {
    const ApiEndpoint = from === "wati" ? "/wati/leads" : "/members";
    const sendableFilters = {
      ...filters,
      auto_gym_map: from === "wati" ? 1 : "",
      training_gym_data: from === "odm" ? 0 : "",
      filter_type:
        from === "unpaid_members"
          ? "unpaid"
          : from === "active_members"
          ? "active"
          : from === "expiring_today"
          ? "expire_today"
          : from === "expiring_this_month"
          ? "expire_month"
          : "",
    };
    getMembers(sendableFilters, ApiEndpoint);
  };

  function getMembers(filters, endpoint) {
    let filteredFilters = { ...filters };

    if (from === "wati") {
      const {
        training_gym_data,
        is_payment_done,
        plan_status,
        not_added_lms_sort,
        date_added_sort,
        gender,
        ...rest
      } = filters;
      filteredFilters = rest;
    } else if (from === "recurring") {
      const {
        convert_start_date,
        convert_end_date,
        keyword_name,
        lead_status,
        not_added_lms_sort,
        date_added_sort,
        training_gym_data,
        gender,
        ...rest
      } = filters;
      filteredFilters = rest;
    } else if (from === "odm") {
      const { keyword_name, lead_status, ...rest } = filters;
      filteredFilters = rest;
    }

    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: filteredFilters,
        },
        token: userInfoData?.token,
      })
    );
  }

  function getLabelFrom(from) {
    if (from === "wati") {
      return "Wati";
    } else if (from === "recurring") {
      return "Recurring 999";
    } else if (from === "lms") {
      return "LMS";
    } else if (from === "unpaid_members") {
      return "Unpaid Members";
    } else return from?.replace(/_/g, " ");
  }

  useEffect(() => {
    const ApiEndpoint =
      from === "odm"
        ? "/subscription/one_day_membership_lead/all"
        : from === "recurring"
        ? "/subscription/tripple-nine"
        : from === "wati" && selectedTab === "untracked-wati-lead"
        ? "/wati/untracked"
        : from === "wati"
        ? "/leads/unassigned"
        : from === "lms"
        ? "/leads/v2"
        : from === "unpaid_members" ||
          from === "active_members" ||
          from === "expiring_this_month" ||
          from === "expiring_today"
        ? "/gym/dashboard/reports/details/v2"
        : from === "biomax"
        ? "/subscription/subs_biomax_info"
        : from === "walkins"
        ? "/leads/walkin"
        : "";

    const sendableFilters = {
      ...filters,
      page: 1,
      limit: 5000,
      auto_gym_map: from === "wati" ? 1 : "",
      training_gym_data: from === "odm" ? 0 : "",
      filter_type:
        from === "unpaid_members"
          ? "unpaid"
          : from === "active_members"
          ? "active"
          : from === "expiring_today"
          ? "expire_today"
          : from === "expiring_this_month"
          ? "expire_month"
          : "",
    };

    getMembers(sendableFilters, ApiEndpoint);

    setFormValues((prev) => ({
      ...prev,
      selectedMembers: [],
      totalMembers: 0,
    }));
  }, [filters]);

  useEffect(() => {
    if (!loading && !error && data?.status && data?.data) {
      const dropdownOptions = data.data?.map((item) => ({
        label: `${item.name || item.user_name || "NA"}/${
          item.mobile || item.user_mobile || ""
        }`,
        value:
          from === "wati" || from === "recurring" || from === "odm"
            ? item.uid
            : from === "lms"
            ? item.lead_id
            : item.user_id,
        info: item,
      }));

      setAllMembers(dropdownOptions);

      setFormValues((prev) => ({
        ...prev,
        totalMembers: data.data?.length,
      }));
    } else {
      setAllMembers([]);
      setFormValues((prev) => ({
        ...prev,
        totalMembers: 0,
      }));
    }
  }, [data, loading, error, from]);

  return (
    <>
      <div className="form-container">
        <form className="formContainer">
          {isSubmit ? (
            <BroadcastCampaignForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              handleBack={handleBackClick}
              selectedMembers={formValues.selectedMembers}
              from={from}
              allFilters={allFilters}
            />
          ) : (
            <>
              {formValues.selectedMembers?.length > 10 && (
                <CloseSubmitBtn
                  submitLabel={"Next"}
                  onSubmit={handleNextClick}
                  isLoading={loading}
                />
              )}

              <div className="formInputsGrid fourGridSystem">
                <div className={`formInputBox span3`}>
                  <label htmlFor="selectedMembers" className={`formInputLabel`}>
                    choose {getLabelFrom(from)} members{" "}
                    {formErrors?.selectedMembers && (
                      <span className="required">*</span>
                    )}
                    <span 
                      className="broadcast-reload-icon"
                      onClick={handleReloadMembers}
                      title="Reload members data"
                    >
                      <ReloadIcon />
                    </span>
                  </label>

                  {loading ? (
                    <Loader />
                  ) : (
                    <div
                      className={`commonWrapper no-border multi-select multi-show-option ${
                        formErrors?.selectedMembers ? "error" : ""
                      }`}
                    >
                      <MultiSelect
                        options={allMembers}
                        state={formValues.selectedMembers}
                        setState={(selectedValue) =>
                          onChangeDropdown(selectedValue, "selectedMembers")
                        }
                        name="select multiple members"
                        preventKeyboardOpen={false}
                        isShowList={true}
                      />
                    </div>
                  )}
                </div>

                <div className="formInputBox">
                  <label htmlFor="totalMembers" className={`formInputLabel`}>
                    total members
                  </label>

                  <input
                    type="number"
                    className={`formInput ${
                      formErrors?.totalMembers ? "formError" : ""
                    }`}
                    name="totalMembers"
                    value={formValues.totalMembers}
                    disabled
                  />

                  <span className="tiny-info-label">
                    ⓘ Upto 5000 members can be fetched at a time!
                  </span>
                </div>
              </div>

              <CloseSubmitBtn
                closeLabel="Cancel"
                submitLabel={"Next"}
                onClose={closeModal}
                onSubmit={handleNextClick}
                isLoading={loading}
              />
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default CommonBroadForm;
